/**
 * pdp-thumbnail-carousel.js
 * Renders a thumbnail strip below the PDP media gallery.
 * Max 5 thumbnails visible, prev/next to page through rest.
 * Clicking a thumbnail calls slideshow.select(index).
 */

(function () {
  var THUMBS_PER_PAGE = 5;

  function init() {
    var leftside = document.querySelector('.product-information__media.Product_information_leftside_new');
    if (!leftside) return;

    var slideshow = leftside.querySelector('slideshow-component');
    if (!slideshow) return;

    // Already built
    if (leftside.querySelector('.pdp-thumbs')) return;

    var slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    if (slides.length < 2) return;

    // Collect images from each slide
    var thumbData = slides.map(function (slide, i) {
      var img = slide.querySelector('img');
      return {
        index: i,
        src: img ? img.src.replace(/&width=\d+/, '&width=200') : '',
        alt: img ? img.alt : ''
      };
    });

    // Build carousel
    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-thumbs';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'pdp-thumbs__btn pdp-thumbs__btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous thumbnails');
    prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>';

    var track = document.createElement('div');
    track.className = 'pdp-thumbs__track';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'pdp-thumbs__btn pdp-thumbs__btn--next';
    nextBtn.setAttribute('aria-label', 'Next thumbnails');
    nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';

    var thumbEls = thumbData.map(function (data) {
      var btn = document.createElement('button');
      btn.className = 'pdp-thumbs__item' + (data.index === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'View image ' + (data.index + 1));
      btn.dataset.index = data.index;

      var img = document.createElement('img');
      img.src = data.src;
      img.alt = data.alt;
      img.loading = 'lazy';
      img.width = 72;
      img.height = 72;

      btn.appendChild(img);
      track.appendChild(btn);
      return btn;
    });

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(track);
    wrapper.appendChild(nextBtn);
    // Insert after the slideshow, not inside leftside which has z-index issues
    slideshow.parentNode.insertBefore(wrapper, slideshow.nextSibling);

    // Pagination state
    var currentPage = 0;
    var totalPages = Math.ceil(thumbData.length / THUMBS_PER_PAGE);

    function goToPage(page) {
      currentPage = Math.max(0, Math.min(page, totalPages - 1));
      var offset = currentPage * THUMBS_PER_PAGE;
      thumbEls.forEach(function (el, i) {
        el.style.display = (i >= offset && i < offset + THUMBS_PER_PAGE) ? '' : 'none';
      });
      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage === totalPages - 1;
    }

    prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
    nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });

    // Thumbnail click → slideshow.select()
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp-thumbs__item');
      if (!btn) return;
      var idx = parseInt(btn.dataset.index, 10);
      slideshow.select(idx);
    });

    // Sync active thumb + page to match current slideshow position
    function syncActive() {
      // Find the current visible slide index via aria-hidden
      var current = 0;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('aria-hidden') === 'false') current = i;
      });
      // Also try slideshow.current as fallback
      if (slideshow.current !== undefined) current = slideshow.current;

      thumbEls.forEach(function (el, i) {
        el.classList.toggle('is-active', i === current);
      });

      // Always update page to keep active thumb visible
      var targetPage = Math.floor(current / THUMBS_PER_PAGE);
      goToPage(targetPage);
    }

    // Watch for slideshow slide changes via event
    slideshow.addEventListener('slideshow:slide-change', syncActive);

    // Watch aria-hidden on each slide as fallback
    slides.forEach(function (slide) {
      new MutationObserver(syncActive).observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    // Watch slideshow current-index attribute
    new MutationObserver(syncActive).observe(slideshow, { attributes: true, attributeFilter: ['current-index', 'initial-slide'] });

    goToPage(0);

    // Hide prev/next if all thumbs fit on one page
    if (totalPages <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }
  }

  // Run on DOMContentLoaded and after variant changes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section/variant changes
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', function () {
    var existing = document.querySelector('.pdp-thumbs');
    if (existing) existing.remove();
    setTimeout(init, 300);
  });
})();
